import React from "react";
import { useInView } from "react-intersection-observer";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";

const ReviewsWidget = ({ sku, position = "left", isDetailsView = false }) => {
	const [inView, ratingsInView] = useInView({
		threshold: 0,
		rootMargin: "50px",
		triggerOnce: true,
	});
	const { langCode } = useGlobalContext();

	ratingsInView &&
		// eslint-disable-next-line no-undef
		ratingSnippet("ruk_rating_snippet", {
			store: "every-foods.com",
			lang: langCode,
			color: "#FFE100",
			linebreak: true,
			usePolaris: !isDetailsView,
			showEmptyStars: false,
			text: "Reviews",
		});

	return (
		<div id={`reviews-${sku}`} ref={inView} className={clsx("flex my-6", position === "center" && "justify-center")}>
			<div className="ruk_rating_snippet" data-sku={sku}></div>
		</div>
	);
};

export default ReviewsWidget;
